import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { SharedPaginationModule } from '@shared/modules/pagination/pagination.module';
import { ShowingPageModule } from '@shared/modules/showing-page/showing-page.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ClipboardModule } from 'ngx-clipboard';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxPermissionsModule } from 'ngx-permissions';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgChartsModule } from 'ng2-charts';
import { TranslateModule } from '@ngx-translate/core';
import { QuillModule } from 'ngx-quill';
import { toastConfig } from '@app/configs/properties.config';
import { UserManagementCompanySelectorComponent } from './components/user-management-company-selector/user-management-company-selector.component';
import { LoaderComponent } from './components/loader/loader.component';
import { Pkcs12UploaderComponent } from './components/pkcs12-uploader/pkcs12-uploader.component';
import { InputWithClipboardComponent } from './components/input-with-clipboard/input-with-clipboard.component';
import { AutoDecimalPipe } from './pipes/auto-decimal.pipe';
import { ReportCompanySelectorComponent } from './components/report-company-selector/report-company-selector.component';
import { ByteFormatPipe } from './pipes/byte-format.pipe';
import { RegisterTypePipe } from './pipes/register-type.pipe';
import { AddressProvinceSelectorComponent } from './components/address-province-selector/address-province-selector.component';
import { CompanySelectorComponent } from './components/company-selector/company-selector.component';
import { TableSortComponent } from './components/table-sort/table-sort.component';
import { SharedDigitalMailboxPaginationModule } from '@shared/modules/digital-mailbox-pagination/digital-mailbox-pagination.module';
import { DigitalMailboxSidebarComponent } from '@shared/components/digital-mailbox-sidebar/digital-mailbox-sidebar.component';
import { DashboardSidebarComponent } from '@shared/components/dashboard-sidebar/dashboard-sidebar.component';
import { ProgressbarModule,ProgressbarConfig } from 'ngx-bootstrap/progressbar';
import { QRCodeModule } from 'angularx-qrcode';
import { TruncatePipe } from '@app/shared/components/dashboard-sidebar/dashboard-sidebar.component';
import { PrintAndPostButtonComponent } from './components/print-and-post-button/print-and-post-button.component'

@NgModule({
  declarations: [
    UserManagementCompanySelectorComponent,
    LoaderComponent,
    Pkcs12UploaderComponent,
    InputWithClipboardComponent,
    AutoDecimalPipe,
    ReportCompanySelectorComponent,
    ByteFormatPipe,
    RegisterTypePipe,
    AddressProvinceSelectorComponent,
    CompanySelectorComponent,
    TableSortComponent,
    DigitalMailboxSidebarComponent,
    DashboardSidebarComponent,
    TruncatePipe,
    PrintAndPostButtonComponent
  ],
  imports: [
    CommonModule,
    QRCodeModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    SharedPaginationModule,
    ShowingPageModule,
    NgSelectModule,
    NgxSpinnerModule,
    ClipboardModule,
    BsDropdownModule,
    NgChartsModule,
    NgxPermissionsModule.forChild(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    QuillModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot(toastConfig),
    TranslateModule,
    SharedDigitalMailboxPaginationModule,
    ProgressbarModule
  ],
  exports: [
    TranslateModule,
    QRCodeModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule, 
    ShowingPageModule,
    ModalModule,
    ToastrModule,
    NgSelectModule,
    TabsModule,
    NgxSpinnerModule,
    ClipboardModule,
    BsDropdownModule,
    SharedPaginationModule,
    ShowingPageModule,
    NgxPermissionsModule,
    QuillModule,
    BsDatepickerModule,
    NgChartsModule,
    UserManagementCompanySelectorComponent,
    LoaderComponent,
    Pkcs12UploaderComponent,
    AutoDecimalPipe,
    CompanySelectorComponent,
    AddressProvinceSelectorComponent,
    ByteFormatPipe,
    RegisterTypePipe,
    ReportCompanySelectorComponent,
    TableSortComponent,
    SharedDigitalMailboxPaginationModule,
    DigitalMailboxSidebarComponent,
    DashboardSidebarComponent,
    PrintAndPostButtonComponent

  ],
})
export class SharedModule {}
